import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

const ENABLE_EDGE_SERVICE_CLI_COMMANDS = 'CLI Command to Enable';
const DISABLE_EDGE_SERVICE_CLI_COMMANDS = 'CLI Command to Disable';

@Component({
    selector: 'enable-disable-edge-service-modal',
    templateUrl: './enable-disable-edge-service-modal.component.html',
})
export class EnableDisableEdgeServiceModalComponent implements OnInit {
    @Input() readonly activeModal: NgbActiveModal;
    @Input() readonly arrayName = '';
    @Input() readonly isEmsEnabled = false;

    selectedTab: string;
    submenuItems: string[] = [ENABLE_EDGE_SERVICE_CLI_COMMANDS, DISABLE_EDGE_SERVICE_CLI_COMMANDS];

    cliCommands = '';

    ngOnInit(): void {
        if (!this.isEmsEnabled) {
            this.onSelectedTabChange(ENABLE_EDGE_SERVICE_CLI_COMMANDS);
        } else {
            this.onSelectedTabChange(DISABLE_EDGE_SERVICE_CLI_COMMANDS);
        }
    }

    onSelectedTabChange(newTab: string): void {
        this.selectedTab = newTab;
        if (newTab === ENABLE_EDGE_SERVICE_CLI_COMMANDS) {
            this.cliCommands = `pureuser@${this.arrayName}:~# puresupport enable edge-management\npureuser@${this.arrayName}:~# puresupport enable edge-agent-update`;
        } else {
            this.cliCommands = `pureuser@${this.arrayName}:~# puresupport disable edge-agent-update\npureuser@${this.arrayName}:~# puresupport disable edge-management`;
        }
    }
}
